import React, { useEffect, useState } from "react";
import "./OwnData.css";
import { Input, Button, Form, Select } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { workspaces_List_ActionHandler } from "../../../../../Redux/Actions/user/WorkspacesList";
import { workspaces_Support_Documents_ActionHandler } from "../../../../../Redux/Actions/user/WorkspaceSupportingDocumentList";
import {
  CreateSupportingDocumentsActionHandler,
  clearDocumentsSupportingData,
} from "../../../../../Redux/Actions/user/BuildQuickCreateSupportingDocumentsAction";
const { TextArea } = Input;
const { Option } = Select;
const OwnData = ({
  workspaceFolderFlag,
  workspace_id,
  folder_id,
  name,
  context,
  handleCreateSupportDocument,
  handleSupportingDocumentButtonClick,
  workspaceId_uc,
  workspaceByIdStatus,
}) => {
  let dispatch = useDispatch();
  const [workspaceId, setWorkspaceId] = useState(null);
  const [refer_data, setRefer_data] = useState("");
  const formRef = React.createRef();
  const workspaceData = useSelector(
    (state) => state?.workspaces_List_Data?.workspace_create_data?.data
  );
  const workspaceFolderListData = useSelector(
    (state) =>
      state?.workspaces_Supporting_Document_FolderList_Data
        ?.workspace_supporting_documentlist_data?.data
  );
  const documentssupportingcreateowndatadata = useSelector(
    (state) =>
      state?.BuildQuickCreateSupportingDocumentsData
        ?.documents_supporting_create_data
  );
  const onFinish = (values) => {
    if (workspace_id || workspaceByIdStatus) {
      workspace_id = workspace_id || workspaceByIdStatus;
    } else {
      workspace_id = values.workspace_id;
    }
    if (folder_id) {
      folder_id = folder_id;
    } else {
      folder_id = values.folder_id;
    }
    const submitObject = {
      workspace_id: parseInt(workspace_id, 10),
      folder_id: parseInt(folder_id, 10),
      name: values.name,
      context: "This is the " + values.name + ":",
      type: "text",
      data: values.data,
    };

    dispatch(CreateSupportingDocumentsActionHandler(submitObject));
  };
  const handleChangeWorkspace = (value) => {
    formRef.current.resetFields(["folder_id"]);
    setWorkspaceId(value);
  };
  useEffect(() => {
    dispatch(workspaces_List_ActionHandler("", ""));
  }, []);
  useEffect(() => {
    if (workspaceId) {
      dispatch(workspaces_Support_Documents_ActionHandler(workspaceId, "", ""));
    }
  }, [workspaceId]);

  useEffect(() => {
    if (workspaceId_uc || workspaceByIdStatus) {
      dispatch(
        workspaces_Support_Documents_ActionHandler(
          workspaceId_uc || workspaceByIdStatus,
          "",
          ""
        )
      );
    }
  }, [workspaceId_uc, workspaceByIdStatus]);

  useEffect(() => {
    if (documentssupportingcreateowndatadata) {
      handleCreateSupportDocument(false);
      handleSupportingDocumentButtonClick(false);
      dispatch(clearDocumentsSupportingData());
    }
  }, [documentssupportingcreateowndatadata, dispatch]);

  const handleFormChange = (changedFields, allFields) => {
    const changedField = changedFields[0];

    if (changedField) {
      const fieldName = Array.isArray(changedField.name)
        ? changedField.name[0]
        : changedField.name;
      if (fieldName === "name") {
        formRef.current.setFieldsValue({
          ["context"]: "This is the " + changedField.value + ":",
        });
      }
    }
  };

  useEffect(() => {
    if (refer_data) {
      formRef.current.setFieldsValue({
        name: `${name} ${refer_data?.split(" ")?.slice(0, 3)?.join(" ")}`,
      });
    }
  }, [refer_data]);

  return (
    <>
      <Form
        name="uploadComputerForm"
        initialValues={{
          name: name,
          context: "This is the " + name + ":",
          workspace_id: workspaceId_uc,
          foler_id: "",
          data: "",
        }}
        onFieldsChange={handleFormChange}
        ref={formRef}
        onFinish={onFinish}
      >
        <div className="supporting-document-1">
          <label>Supporting document name</label>
          <Form.Item
            name="name"
            rules={[
              {
                required: true,
                message: "Please input your name!",
              },
              {
                type: "name",
                message: "Please enter a valid name",
              },
            ]}
          >
            <Input placeholder="Enter your name" />
          </Form.Item>
        </div>
        {/* <div className="supporting-document-2">
          <label>Context to frame reference data (edit if required)</label>
          <Form.Item
            name="context"
            rules={[
              {
                required: true,
                message: "Please input your context!",
              },
              {
                type: "name",
                message: "Please enter a valid context",
              },
            ]}
          >
            <Input placeholder="Enter your context" />
          </Form.Item>
        </div> */}
        <div className="own-data-2">
          <label>Reference data</label>
          <Form.Item
            name="data"
            rules={[
              {
                required: true,
                message: "Please select the data!",
              },
            ]}
          >
            <TextArea
              rows={4}
              onChange={(e) => setRefer_data(e.target.value)}
            />
          </Form.Item>
          {workspaceFolderFlag ? null : (
            <>
              <div className="own-data-modal-div">
                <h3>Select Destination Directory</h3>
              </div>
              <div className="own-data-input">
                {!workspaceByIdStatus && (
                  <div className="own-data-1">
                    <label>Select Workspace</label>
                    <Form.Item
                      name="workspace_id"
                      rules={[
                        {
                          required: true,
                          message: "Please select a workspace!",
                        },
                      ]}
                    >
                      <Select
                        className="uploadcomputer-select"
                        onChange={handleChangeWorkspace}
                      >
                        {workspaceData &&
                          workspaceData.map((workspace) => (
                            <>
                              {!workspace.is_locked && (
                                <Option key={workspace.id} value={workspace.id}>
                                  {workspace.name}
                                </Option>
                              )}
                            </>
                          ))}
                      </Select>
                    </Form.Item>
                  </div>
                )}
                <div className="own-data-2">
                  <label>Select Folder</label>
                  <Form.Item
                    name="folder_id"
                    rules={[
                      {
                        required: true,
                        message: "Please select a folder!",
                      },
                    ]}
                  >
                    <Select className="uploadcomputer-select" name="folder_id">
                      {workspaceFolderListData &&
                        workspaceFolderListData.map((folder) => (
                          <Option key={folder.id} value={folder.id}>
                            {folder.name}
                          </Option>
                        ))}
                    </Select>
                  </Form.Item>
                </div>
              </div>
            </>
          )}
          <div className="own-data-supporting-div">
            <Form.Item>
              <Button
                type="primary"
                htmlType="submit"
                block
                className="own-data-supporting-button"
              >
                Create Supporting Document
              </Button>
            </Form.Item>
          </div>
        </div>
      </Form>
    </>
  );
};
export default OwnData;
